<template>
  <div class="paper-syllabus-final-verify">
    <PaperWrap :fetch-url="fetchUrl">
      <template #default="{paperBatchId}">
        <div class="cont-wrap">
          <template v-if="paperBatchId">
            <TemplateDataGrid :key="paperBatchId"
                            ref="grid"
                            gridId="PaperSyllabusFinalVerify"
                            v-bind="{paperBatchId}"></TemplateDataGrid>
          </template>
          <Hint v-else>请先选择论文批次</Hint>
        </div>
      </template>
    </PaperWrap>
  </div>
</template>

<script>
import PaperWrap from '../../wrap'
import Hint from '../../../../../../elements/Hint.vue'
import TemplateDataGrid from '../../../../../../templates/TemplateDataGrid'
export default {
  name: 'PaperSyllabusFinalVerify',
  components: {
    PaperWrap,
    Hint,
    TemplateDataGrid
  },
  data () {
    return {
      fetchUrl: '/workspace/manager/paper/syllabus/queryPaperList'
    }
  }
}
</script>

<style scoped lang="scss">
.paper-syllabus-final-verify{
  height: 100%;
  .cont-wrap{
    height: 100%;
  }
}
</style>
